import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_kiosk_event.js";
//#region src/bite_log_kiosk_event_helper.ts
var bite_log_kiosk_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "update";
		case 2: return "turned-off";
		case 3: return "turned-off-indefinitely";
		case 4: return "turned-on";
		case 11: return "notification-sent";
		case 12: return "notification-send-error";
		case 16: return "push-sent";
		case 17: return "push-send-error";
		case 21: return "status-missing";
		case 22: return "status-recovered";
		case 31: return "enabled-ada";
		case 32: return "enable-ada-error";
		case 36: return "disabled-ada";
		case 37: return "disable-ada-error";
		case 41: return "moved-mdm-group";
		case 42: return "move-mdm-group-error";
		case 43: return "device-reboot";
		case 44: return "device-reboot-error";
		case 51: return "inactive (no sales in the last hour)";
	}
}
//#endregion
export { bite_log_kiosk_event_helper_exports, name };

//# sourceMappingURL=bite_log_kiosk_event_helper.js.map